import React, { forwardRef } from 'react';
import { HiPaintBrush } from "react-icons/hi2";
import { RiDeleteBin6Line } from "react-icons/ri";
import { IconButton, TextField } from '@mui/material';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';


const Item = forwardRef(
    (
        {
            withOpacity,
            isDragging,
            style,
            index,
            onEdit,
            onDelete,
            setCaptions,
            bucketUrl,
            SetVideoId,
            setVideoPlayer,
            setVideoLink,
            imageThumbnailUrl,
            HandleSaveCaption,
            captions,
            item,
            onPressEdit,
            onPressDelete,
            dragHandleProps = {},
            label,
            ...props
        },
        ref
    ) => {
        const imageBoxStyle = {
            opacity: withOpacity ? '0.5' : '1',
            transformOrigin: '50% 50%',
            height: '126px',
            width: '156px',
            cursor: 'default',
            backgroundImage: `url(${imageThumbnailUrl})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            transform: isDragging ? 'scale(1.05)' : 'scale(1)',
            position: 'relative',
            overflow: 'hidden',
            ...style,
        };

        const iconStyleBase = {
            opacity: 0,
            transition: 'opacity 0.2s ease',
            pointerEvents: 'auto',
        };

        return (
            <div
                {...props}
                ref={ref}
                style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}
                onMouseEnter={(e) => {
                    if (!isDragging) {
                        e.currentTarget.querySelectorAll('.hover-icon').forEach((el) => {
                            el.style.opacity = 1;
                        });
                    }
                }}
                onMouseLeave={(e) => {
                    e.currentTarget.querySelectorAll('.hover-icon').forEach((el) => {
                        el.style.opacity = 0;
                    });
                }}
            >
                {/* Image Box */}
                <div style={imageBoxStyle} onClick={() => {
                    if (item?.filetype?.includes("video")) {
                        setVideoPlayer(true);
                        SetVideoId(item?.id);
                        setVideoLink(`${bucketUrl}${item.onlineUrl}`); // or videoUrl if you have it defined
                    } else {
                        onPressEdit();
                    }
                }}>
                    {/* Drag Handle (Top Left) */}
                    {!isDragging && (
                        <div
                            className="hover-icon"
                            style={{
                                position: 'absolute',
                                top: '6px',
                                left: '6px',
                                background: '#fff',
                                borderRadius: '4px',
                                padding: '2px',
                                zIndex: 2,
                                border: '1px solid #ccc',
                                ...iconStyleBase,
                            }}
                            {...dragHandleProps}
                        >
                            <IconButton size="small" sx={{ padding: '2px' }}>
                                <DragIndicatorIcon fontSize="inherit" sx={{ color: '#000', fontSize: '16px' }} />
                            </IconButton>
                        </div>
                    )}
                    {/* ▶️ Play Icon in Center for videos */}
                    {item?.filetype?.includes("video") && (
                        <div
                            style={{
                                position: 'absolute',
                                top: '50%',
                                left: '50%',
                                transform: 'translate(-50%, -50%)',
                                backgroundColor: '#fff',        // white background
                                borderRadius: '50%',
                                padding: '8px',
                                zIndex: 2,
                                pointerEvents: 'none',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                opacity: "70%"
                            }}
                        >
                            <PlayArrowIcon sx={{ fontSize: '28px' }} />
                        </div>
                    )}


                    {/* Edit/Delete Icons (Bottom Right) */}
                    {!isDragging && (
                        <div
                            className="hover-icon"
                            style={{
                                position: 'absolute',
                                bottom: '6px',
                                right: '6px',
                                display: 'flex',
                                gap: '0px',
                                background: '#fff',
                                borderRadius: '6px',
                                overflow: 'hidden',
                                border: '1px solid #ccc',
                                zIndex: 2,
                                ...iconStyleBase,
                            }}
                        >
                            {!item?.filetype?.includes("video") ? <IconButton
                                size="small"
                                onClick={(e) => {
                                    e.stopPropagation(); // 👈 Prevent triggering image click
                                    onPressEdit();
                                }}
                                sx={{
                                    borderRight: '1px solid #ccc',
                                    padding: '4px',
                                    borderRadius: 0,
                                }}
                            >
                                <HiPaintBrush color='#3b3b3b' fontSize="medium" />
                            </IconButton> : null}
                            <IconButton
                                size="small"
                                onClick={(e) => {
                                    e.stopPropagation(); // 👈 Prevent triggering image click
                                    onPressDelete();
                                }}
                                sx={{
                                    padding: '4px',
                                    borderRadius: 0,
                                }}
                            >
                                <RiDeleteBin6Line color='red' fontSize="medium" />
                            </IconButton>
                        </div>
                    )}
                </div>
                {/* Caption Text */}
                {!isDragging && (
                    <TextField
                        id={`caption-input-${item?.uuid}`}
                        className="caption-input-textfield"
                        size="small"
                        variant="outlined"
                        type="text"
                        value={captions[item?.id] || ""}
                        placeholder="+ Add caption"
                        onChange={(e) => {
                            setCaptions((prev) => ({
                                ...prev,
                                [item.id]: e.target.value,
                            }));
                        }}
                        onBlur={(e) => HandleSaveCaption(item.id, e.target.value)}
                        sx={{
                            borderRadius: "4px",
                            width: "156px",
                            marginTop: "2px",
                            height: "34px !important",
                            "& .MuiOutlinedInput-root": {
                                height: "34px",
                                fontSize: "14px",
                                "&:hover .MuiOutlinedInput-notchedOutline": {
                                    borderColor: "#ccc",
                                },
                                "& .MuiOutlinedInput-notchedOutline": {
                                    borderColor: "#ccc",
                                },
                                "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                    borderColor: "#ccc",
                                },
                            },
                        }}
                    />
                )}

            </div>
        );
    }
);

export default Item;
